import React from "react";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { InlineAlert } from "@/features/betslip/components/parts/InlineAlert";
import { redundantLegAlert } from "@/features/betslip/utils/alerts";

type SemLegAlertProps = {
  semOutcomeId: string;
  legOutcomeId: string;
};

export const SemLegAlert = ({
  semOutcomeId,
  legOutcomeId,
}: SemLegAlertProps) => {
  const isRedundant = useBetslipStore(
    (state) =>
      state.semRedundantLegs[semOutcomeId]?.includes(legOutcomeId) ?? false,
  );

  if (!isRedundant) return null;

  return <InlineAlert alert={redundantLegAlert} />;
};
